import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs';
import { startWith, distinctUntilChanged, tap, filter, map, skipWhile, mergeMap } from 'rxjs/operators';
import {FormControl, AbstractControl, FormGroup} from '@angular/forms';
import { EvkOption } from '@evomatik/evk-common';


export const filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges? : Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$ 
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]) => name ? _filter(name, opciones) : opciones.slice())
        );

    };
export const filterOptionsv2 = (form: FormGroup, formControl: string, opciones$: Observable<EvkOption[]>) => {
    return combineLatest(
        [
            form.controls[formControl].valueChanges.pipe(startWith('')),
            opciones$
        ]
    ).pipe(
        filter(([value, _]) => typeof value === 'string'
        ),
        map(([name, opciones]) => name ? _filter(name, opciones) : opciones.slice())
    );
};
export function _filter(label: string, options: EvkOption[]): EvkOption[] {
        const filterValue = removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
}

export const removeAccents = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
export function getOptionsOnChange(valueChanges: Observable<any>, formControl: FormControl | AbstractControl, fun: (value) => Observable<EvkOption[]>): Observable<EvkOption[]>{
        return valueChanges.pipe(skipWhile(val => !val || !val.value), mergeMap(val => {
            formControl.patchValue('');
            if (val && val.value){
                return fun(val.value);
            }
            return of([]);
        }));
}
export function buildOption(expediente: any, labelProp: string): any {
        const folio = expediente[labelProp];
        return {
            label: folio,
            value: expediente['id'],
            active: expediente['activo']
        };
}
export function expedienteListToEvkOptions(expedientesList: any[]): EvkOption[]{
                const buildOptions = (data: any, labelProp: string) => {
                    const folio = data[labelProp];
                    return {
                        label: folio,
                        value: data['id'],
                        active: data['activo']
                    };

                };
                const expedientes = [];
                expedientesList.forEach(element => {
                    if (element.idTipoSolicitud !== null && element.idTipoSolicitud !== undefined) {
                        let expediente = {};
                        if (element.idTipoSolicitud === '2') {
                            expediente = buildOption(element, 'folioNic');
                        } else if (element.idTipoSolicitud === '1') {
                            if (element.folioNuc !== null && element.folioNuc !== undefined) {
                                expediente = buildOption(element, 'folioNuc');
                            } else {
                                expediente = buildOption(element, 'folioNic');
                            }
                        }
                        let adicional = '';
                        if (element.sustentosExpedientes != null) {
                            adicional = expediente['label'] + ' - ' + element.sustentosExpedientes.delito.label;
                            expediente['label'] = adicional;
                        }
                        expedientes.push(expediente)
                    }
                });
                return expedientes;
}
export function hasRol(...roles) {
        for (const rol of roles) {
            if (localStorage.getItem('roles').includes(rol)) {
                return true;
            }
        }
        return false;
}
